import React, { useState } from 'react'

import { connect } from 'react-redux'
import { getSelectedStore } from 'x/redux/selectors'

import { TouchableOpacity, View } from 'react-native'

import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as util from 'x/utils/util'
import * as api from 'x/utils/api'
import { COLORS, S } from 'x/config/styles'
import {
  IQtyAdjustmentViewProps,
  IQtyAdjustmentViewState,
  ISearchProductItem,
  IBarcodeScannerOutput,
  ISearchProductVariantListViewNavParams,
  IXSegmentOption,
  ISearchInventoryProductsParams,
  IQtyAdjustReason,
} from 'x/index'

// import BackIcon from 'xui/components/BackIcon'
import VStack from 'xui/components/VStack'
import XText from 'xui/components/XText'
import XContent from 'xui/components/XContent'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import * as NavActions from 'x/utils/navigation'
import _ from 'lodash'
import HStack from 'xui/components/HStack'
import XImage from 'xui/components/XImage'
import CollapsableCard from 'xui/components/CollapsableCard'
import BarcodeScannerWithSegment from 'xui/components/BarcodeScannerWithSegment'
import XInput from 'xui/components/XInput'
import XSegment from 'xui/components/XSegment'
import XOverlay from 'xui/components/XOverlay'
import XNumericInput from 'xui/components/XNumericInput'
import XIconButton from 'xui/components/XIconButton'
import XIcon from 'xui/components/XIcon'
import XCard from 'xui/components/XCard'
import Box from 'xui/components/Box'
import XSwitch from 'xui/components/XSwitch'
import XKeyboardAvoidingView from 'xui/components/XKeyboardAvoidingView'

import { ADJUST_ADD_REASON_OPTIONS, ADJUST_DEDUCT_REASON_OPTIONS } from './QtyAdjustmentView'

interface IFillExtraDataCard {
  isFillExtraDataExpanded: boolean
  onPressFillExtraDataToggle: (nextExpended: boolean) => void
  refCode: string
  note: string
  orderId: string
  onChangeRefCode: (text: string) => void
  onChangeNote: (text: string) => void
  onChangeOrderId: (text: string) => void
  mode?: 'set' | 'add' | 'deduct' | 'count'
  selectedReason?: IXSegmentOption<IQtyAdjustReason>
  onSelectReason: (reason: IXSegmentOption<IQtyAdjustReason>, index: number) => void
  colorScheme: string
}

export default class FillExtraDataCard extends React.Component<IFillExtraDataCard> {
  _renderFillExtraDataContent = () => {
    const { refCode, note, orderId, onChangeOrderId, onChangeNote, onChangeRefCode } = this.props
    return (
      <VStack w='full' p='2' space='2'>
        {this._renderReasonSelector()}

        <VStack w='full' space='1'>
          <HStack alignItems={'center'}>
            <XText variant='inactive'>เลขออเดอร์</XText>
            <XText variant='inactive' fontSize={'xs'} ml='1'>
              (ไม่จำเป็นต้องระบุ)
            </XText>
          </HStack>
          <XInput placeholder='ระบุเลขออเดอร์ใน XSelly หรือจากช่องทางขาย' value={orderId} onChangeText={(text) => onChangeOrderId(text)} />
        </VStack>

        <VStack w='full' space='1'>
          <HStack alignItems={'center'}>
            <XText variant='inactive'>รหัสอ้างอิง</XText>
            <XText variant='inactive' fontSize={'xs'} ml='1'>
              (ไม่จำเป็นต้องระบุ)
            </XText>
          </HStack>
          <XInput placeholder='ระบุรหัสอ้างอิง เช่น PO123456' value={refCode} onChangeText={(text) => onChangeRefCode(text)} />
        </VStack>

        <VStack w='full' space='1' pb={p.op.isWeb() ? '0' : '4'}>
          <HStack alignItems={'center'}>
            <XText variant='inactive'>หมายเหตุ</XText>
            <XText variant='inactive' fontSize={'xs'} ml='1'>
              (ไม่จำเป็นต้องระบุ)
            </XText>
          </HStack>
          <XInput
            placeholder='ระบุหมายเหตุ เช่น เติมสินค้าจากสำนักงานใหญ่'
            value={note}
            onChangeText={(text) => onChangeNote(text)}
            multiline
            style={{ minHeight: 60 }}
          />
        </VStack>
      </VStack>
    )
  }

  _getHeaderTitle = () => {
    let title = util.getNavParam(this.props, 'title', null)

    if (_.isString(title)) {
      return title
    }

    const { mode } = this.props

    if (mode === 'add') {
      title = `เพิ่มจำนวนสินค้า`
    }

    if (mode === 'deduct') {
      title = `ลดจำนวนสินค้า`
    }

    if (mode === 'set') {
      title = `ปรับจำนวนสินค้า`
    }

    if (mode === 'count') {
      title = 'นับสต๊อกสินค้า'
    }

    return title
  }

  _renderReasonSelectorItem = (opt: IXSegmentOption<IQtyAdjustReason>, index: number) => {
    const { selectedReason, onSelectReason } = this.props
    const checked = selectedReason && selectedReason.key === opt.key

    // eslint-disable-next-line @typescript-eslint/no-shadow
    const _onSelectReason = (reason: IXSegmentOption<IQtyAdjustReason>, index: number) => {
      onSelectReason(reason, index)
    }
    return (
      <HStack key={`qa-reason-${opt.key}_${index}`} pb='1'>
        <TouchableOpacity onPress={() => _onSelectReason(opt, index)}>
          <HStack
            px='2'
            py='1'
            space='1'
            alignItems='center'
            borderWidth='1'
            borderColor={checked ? 'gray.400' : 'gray.200'}
            borderRadius='lg'>
            {/* {checked ? <XIcon name='checkmark' /> : <XIcon name='checkmark' color='transparent' />} */}
            {checked ? <XIcon name='checkmark' /> : <Box h='24px' w='1px' />}
            <XText variant={checked ? 'active' : 'inactive'} numberOfLines={1}>
              {opt.label}
            </XText>
          </HStack>
        </TouchableOpacity>
      </HStack>
    )
  }

  _renderReasonSelector = () => {
    const { mode } = this.props
    if (_.isNil(mode)) {
      return null
    }
    if (mode === 'set' || mode === 'count') {
      return null
    }

    return (
      <VStack w='full' space='1'>
        <XText variant='inactive'>{`เหตุผลการ${this._getHeaderTitle()}`}</XText>
        <HStack w='full' space='1.5'>
          {mode === 'add' && ADJUST_ADD_REASON_OPTIONS.map(this._renderReasonSelectorItem)}
          {mode === 'deduct' && ADJUST_DEDUCT_REASON_OPTIONS.map(this._renderReasonSelectorItem)}
        </HStack>
      </VStack>
    )
  }

  _getColorScheme = () => {
    return this.props.colorScheme
  }

  _getSectionBarInlineColorStyle = (isExpand: boolean) => {
    const colorScheme = this._getColorScheme()

    const styled = {
      borderWidth: '1',
      bg: `${colorScheme}.100`,
      borderLeftColor: `${colorScheme}.600`,
      borderTopColor: `${colorScheme}.600`,
      borderRightColor: `${colorScheme}.700`,
      borderBottomColor: `${colorScheme}.700`,
      borderTopLeftRadius: 'lg',
      borderTopRightRadius: 'lg',
      borderBottomLeftRadius: 'lg',
      borderBottomRightRadius: 'lg',
    }

    if (isExpand) {
      styled.borderBottomLeftRadius = 'none'
      styled.borderBottomRightRadius = 'none'
    }

    return styled
  }

  render() {
    // const [selectedPaymentAccount, setSelectedPaymentAccount] = useState(null)
    const { isFillExtraDataExpanded, onPressFillExtraDataToggle } = this.props

    return (
      <CollapsableCard
        disabledAnimation
        // disabled={props.disabled}
        expanded={isFillExtraDataExpanded}
        onPressToggle={(nextExpended) => onPressFillExtraDataToggle(nextExpended)}
        renderContent={this._renderFillExtraDataContent}>
        <HStack h='44px' w='full' p='2' alignItems='center' {...this._getSectionBarInlineColorStyle(isFillExtraDataExpanded)}>
          <VStack flex={1}>
            <XText variant='inactive' bold>
              ระบุข้อมูลอ้างอิง
            </XText>
          </VStack>

          <HStack w='38px' justifyContent='flex-end' alignItems='center'>
            <XIcon
              variant='inactive'
              size='xs'
              name={isFillExtraDataExpanded ? 'arrow-collapse-up' : 'arrow-expand-down'}
              family='MaterialCommunityIcons'
            />
          </HStack>
        </HStack>
      </CollapsableCard>
    )
  }
}
